import {Injectable} from '@angular/core';
import {CommonService} from './common.service';
import {Pagination} from '../constants';
import {Observable} from 'rxjs';
import {ResponseResult} from '../interfaces';
@Injectable({
    providedIn: 'root'
})

export class UserService {
    constructor(private commonService: CommonService) {
    }

    getAll(pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
        return this.commonService.getAll(`users`, false, pageSize, pageIndex);
    }

    getMemberRegister(pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
        return this.commonService.getAll(`users/register`, false, pageSize, pageIndex);
    }

    getUserImport(pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
        return this.commonService.getAll(`users/from-import`, false, pageSize, pageIndex);
    }
    getFarmerFilter(model: any): Observable<ResponseResult> {
        return this.commonService.getDataByBody(`users/farmer-filter`, model);
    }
    getByUserGroupId(id: number, pageIndex: number = Pagination.PageIndex, leaderId: number = 0, provinceId: number = 0, districtId: number = 0, wardId: number = 0, pageSize: number = Pagination.PageSize): Observable<ResponseResult> {
        if (!provinceId) {
            provinceId = 0;
        }
        if (!districtId) {
            districtId = 0;
        }
        if (!wardId) {
            wardId = 0;
        }
        return this.commonService.getAll(`users/user-groups/${id}?leaderId=${leaderId}&provinceId=${provinceId}&districtId=${districtId}&wardId=${wardId}`, true, pageSize, pageIndex);
    }

    getByUserMaps(id: number, pageIndex: number = Pagination.PageIndex, leaderId: number = 0, pageSize: number = Pagination.PageSize): Observable<ResponseResult> {
        return this.commonService.getAll(`users/user-maps/${id}?leaderId=${leaderId}`, true, pageSize, pageIndex);
    }

    getUserRoles(id: number): Observable<ResponseResult> {
        return this.commonService.getById(`users/user-groups/${id}/user-roles`);
    }

    getById(id: number): Observable<ResponseResult> {
        return this.commonService.getById(`users/${id}/detail`);
    }

    getAvatarById(id: number): Observable<ResponseResult> {
        return this.commonService.getById(`users/${id}/avatar`);
    }

    create(model): Observable<ResponseResult> {
        return this.commonService.createData(`users`, model, model.langId, model.parentId);
    }

    createRating(model): Observable<ResponseResult> {
        return this.commonService.createData(`users/rating`, model);
    }

    getRating(id: number): Observable<ResponseResult> {
        return this.commonService.getById(`users/${id}/rating`);
    }

    update(model): Observable<ResponseResult> {
        return this.commonService.updateData(`users/${model.userId}`, model);
    }

    updateUserRole(userId: number, model): Observable<ResponseResult> {
        return this.commonService.updateData(`users/user-role/${userId}`, model);
    }

    delete(id): Observable<ResponseResult> {
        return this.commonService.deleteData(`users/${id}`);
    }

    // todo: create api delete user partner with param userId, partnerId
    deleteUserWithPartner(userId, partnerId): Observable<ResponseResult> {
        return this.commonService.deleteData(`user-partner/${userId}/${partnerId}`);
    }


    // agronomist
    getByUserByRole(id: number, pageIndex: number = Pagination.PageIndex, provinceId: number = 0, districtId: number = 0, wardId: number = 0, pageSize: number = Pagination.PageSize): Observable<ResponseResult> {
        if (!provinceId) {
            provinceId = 0;
        }
        if (!districtId) {
            districtId = 0;
        }
        if (!wardId) {
            wardId = 0;
        }
        return this.commonService.getAll(`users/user-by-role/${id}?provinceId=${provinceId}&districtId=${districtId}&wardId=${wardId}`,
            true, pageSize, pageIndex);
    }

    createByRole(model): Observable<ResponseResult> {
        return this.commonService.createData(`users/create-by-role`, model, model.langId, model.parentId);
    }

    GetByUserPartnerMainId(id: number, pageIndex: number = Pagination.PageIndex, mainId: number = 0, provinceId: number = 0, districtId: number = 0, wardId: number = 0, pageSize: number = Pagination.PageSize): Observable<ResponseResult> {
        if (!provinceId) {
            provinceId = 0;
        }
        if (!districtId) {
            districtId = 0;
        }
        if (!wardId) {
            wardId = 0;
        }
        return this.commonService.getAll(`users/user-partner-main/${id}?mainId=${mainId}&provinceId=${provinceId}&districtId=${districtId}&wardId=${wardId}`, true, pageSize, pageIndex);
    }

    createAgronomist(model): Observable<ResponseResult> {
        return this.commonService.createData(`users/create-agronomist`, model);
    }

    createWithPartner(model): Observable<ResponseResult> {
        return this.commonService.createData(`users/create-with-partner`, model);
    }

    updateWithPartner(model): Observable<ResponseResult> {
        return this.commonService.updateData(`users/${model.userId}/update-with-partner`, model);
    }

    getFarmers(partnerType: number = 1): Observable<ResponseResult> {
        return this.commonService.getById(`users/get-farmer/${partnerType}`);
    }

    addPartnerMember(model): Observable<ResponseResult> {
        return this.commonService.createData(`users/add-partner-member`, model);
    }

    getDetailWithPartnerId(id: number): Observable<ResponseResult> {
        return this.commonService.getById(`users/${id}/detail-with-partner`);
    }

    // getAvailableGuest(id: number, userGroupId: number, pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
    //     return this.commonService.getAll(`users/available-user-for-event?id=${id}&userGroupId=${userGroupId}`, true, pageSize, pageIndex);
    // }
    getAvailableGuest(model: any): Observable<ResponseResult> {
        return this.commonService.getDataByBody(`users/available-user-for-event`, model);
    }
    getUserInvited(id: number, model: any, pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
        let url = `users/user-invited-event/${id}?`;
        if (model.ProvinceId) {
            url = url + `ProvinceId=${model.ProvinceId}`;
        }

        if (model.DistrictId) {
            url = url + `&DistrictId=${model.DistrictId}`;
        }

        if (model.WardId) {
            url = url + `&WardId=${model.WardId}`;
        }

        return this.commonService.getAll(url, true, pageSize, pageIndex);
    }

    getFarmerForSelect(): Observable<ResponseResult> {
        return this.commonService.getById(`users/get-farmer-for-select`);
    }

    getFarmerForSelectWithParam(filter): Observable<ResponseResult> {
        let url = `users/get-farmer-for-select`;
        if (filter) {
            url = url + `?provinceIds=${filter}`;
        }
        return this.commonService.getById(url);
    }

    getFermenterForSelect(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `users/get-fermenter-for-select`,
            model,
            '',
            '0');
    }

    updateFarmerInfo(formData: any): Observable<ResponseResult> {
        // Send a POST request to update the farmer information
        return this.commonService.updateData(`users/update-farmer-information`, formData);
    }

    getDetailFarmerInfobyId(id: number): Observable<ResponseResult> {
        return this.commonService.getById(`users/${id}/farmer-information`);
    }
}
